import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import Asd20Button from '@asd20/ui/src/components/atoms/Asd20Button'
import ClientOnly from '@asd20/ui/src/components/utils/ClientOnly'
import Asd20Icon from '@asd20/ui/src/components/atoms/Asd20Icon'
import scrollTrack from '@asd20/ui/src/directives/scroll-track'
import VueMq from 'vue-mq'
import VueLazyload from 'vue-lazyload'
import VueResize from 'vue-resize'
import 'vue-resize/dist/vue-resize.css'
import { sync } from 'vuex-router-sync'
import sendEmail from './helpers/sendEmail'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_ID },
})
Vue.use(VueMq)
Vue.use(VueResize)
Vue.use(VueLazyload)
Vue.directive('scroll-track', scrollTrack)

Vue.config.productionTip = false

Vue.component('Asd20Button', Asd20Button)
Vue.component('Asd20Icon', Asd20Icon)
Vue.component('ClientOnly', ClientOnly)

sync(store, router, { moduleName: 'route' })

Vue.prototype.$sendEmail = async message =>
  await sendEmail(message, process.env.VUE_APP_SEND_EMAIL_ENDPOINT)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
